"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReactRouterAuthGuard = void 0;
var react_1 = __importDefault(require("react"));
var react_router_dom_1 = require("react-router-dom");
/**
 * Component that renders a conditional Route. If the user is not authenticated, this route
 * will redirect to the route specified by user using fallBackUrl prop. If the user is authenticated, it will render the provided
 * content.
 * @param children The element/route to render if the user is authenticated
 * @param isAuthenticated Indicates whether the user is authenticated or not
 * @param fallBackUrl URL where to redirect if user is not authenticated
 *
 * @category Component
 */
var ReactRouterAuthGuard = function (props) {
    var _a = props.children, children = _a === void 0 ? null : _a, fallBackUrl = props.fallBackUrl, isAuthenticated = props.isAuthenticated;
    var location = (0, react_router_dom_1.useLocation)();
    if (!isAuthenticated) {
        return react_1.default.createElement(react_router_dom_1.Navigate, { to: fallBackUrl, replace: true, state: { from: location } });
    }
    return children;
};
exports.ReactRouterAuthGuard = ReactRouterAuthGuard;
